import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Sales Engineer Lab Automation",
      description: "Designed and orchestrated dynamic, automated lab environments for Sales Engineers at VAST Data. Reduced cluster setup time from 2+ hours to under 1 hour, enabling reproducible results and consistent rebuilds.",
      technologies: ["Ansible", "Terraform", "Python", "Linux"],
      image: "🔬",
      liveUrl: "",
      githubUrl: "",
      featured: true
    },
    {
      id: 2,
      title: "Developer Onboarding Automation",
      description: "Streamlined developer onboarding at Argo AI by creating automated scripts that reduced new hire setup time from 2+ hours to just 30 minutes. Built one-step onboarding scripts enabling developers to commit code on day one with fully configured development environments.",
      technologies: ["Shell Scripting", "Linux", "Automation", "Python"],
      image: "🚀",
      liveUrl: "",
      githubUrl: "",
      featured: true
    },
    {
      id: 3,
      title: "UltraPackr.com",
      description: "A comprehensive race day planning website designed specifically for ultra marathon athletes. Features intelligent packing lists, nutrition scheduling, pacing strategies, and crew coordination tools to help ultrarunners prepare for and execute successful race day plans.",
      technologies: ["React", "JavaScript", "CSS3", "Responsive Design"],
      image: "🏃‍♂️",
      liveUrl: "https://ultrapackr.com",
      githubUrl: "#",
      featured: false
    },
    {
      id: 4,
      title: "Multi-Datacenter Implementation",
      description: "Led datacenter implementation across Ashburn VA, San Jose CA, and Amsterdam NL. Managed Cisco UCSM, PureStorage arrays, and VMware infrastructure with automated VM provisioning via Terraform.",
      technologies: ["Cisco UCSM", "PureStorage", "VAST Data", "VMware", "Terraform"],
      image: "🏢",
      liveUrl: "#",
      githubUrl: "#",
      featured: false
    }
  ];

  const featuredProjects = projects.filter(project => project.featured);
  const otherProjects = projects.filter(project => !project.featured);

  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="section-title text-center">Featured Projects</h2>
        <p className="section-subtitle text-center">
          Key enterprise projects and automation solutions I've architected and delivered
        </p>
        
        {/* Featured Projects */}
        <div className="featured-projects">
          {featuredProjects.map((project) => (
            <div key={project.id} className="project-card featured">
              <div className="project-image">
                <div className="project-emoji">{project.image}</div>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.liveUrl && project.liveUrl !== "#" && (
                    <a href={project.liveUrl} className="btn btn-primary">
                      View Live
                    </a>
                  )}
                  {project.githubUrl && project.githubUrl !== "#" && (
                    <a href={project.githubUrl} className="btn btn-secondary">
                      View Code
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Other Projects */}
        <div className="other-projects">
          <h3 className="other-projects-title">Other Projects</h3>
          <div className="projects-grid">
            {otherProjects.map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-header">
                  <div className="project-emoji small">{project.image}</div>
                  <h4 className="project-title">{project.title}</h4>
                </div>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag small">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.liveUrl && project.liveUrl !== "#" && (
                    <a href={project.liveUrl} className="project-link">View Live</a>
                  )}
                  {project.githubUrl && project.githubUrl !== "#" && (
                    <a href={project.githubUrl} className="project-link">Code</a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;